export default __webpack_public_path__ + "static/media/usdt_icon.94b11d77.png";